import { gql } from "@apollo/client";

export const CREATE_ASSET = gql`
  mutation CreateAsset($asset: CreateAssetInput) {
    createAsset(asset: $asset) {
      _id
      id
      customer_id
      customer_business_name
      contact_id
      name
      created_at
      updated_at
      asset_serial
      asset_type
      asset_type_id
      make
      model
      service_tag
      warranty
      warranty_type
      warranty_end_date
      warranty_start_date
    }
  }
`;

export const CREATE_ASSETS = gql`
  mutation CreateAssets($assets: [CreateAssetInput]) {
    createAssets(assets: $assets) {
      _id
      id
      customer_id
      customer_business_name
      contact_id
      name
      created_at
      updated_at
      asset_serial
      asset_type
      asset_type_id
      make
      model
      service_tag
      warranty
      warranty_type
      warranty_end_date
      warranty_start_date
    }
  }
`;

export const UPDATE_ASSET = gql`
  mutation UpdateAsset($asset: UpdateDeleteAssetInput!) {
    updateAsset(asset: $asset) {
      _id
      id
      customer_id
      customer_business_name
      contact_id
      name
      created_at
      updated_at
      asset_serial
      asset_type
      asset_type_id
      make
      model
      service_tag
      warranty
      warranty_type
      warranty_end_date
      warranty_start_date
    }
  }
`;

export const UPDATE_ASSETS = gql`
  mutation UpdateAssets($assets: [UpdateDeleteAssetInput]) {
    updateAssets(assets: $assets) {
      _id
      id
      customer_id
      customer_business_name
      contact_id
      name
      created_at
      updated_at
      asset_serial
      asset_type
      asset_type_id
      make
      model
      service_tag
      warranty
      warranty_type
      warranty_end_date
      warranty_start_date
    }
  }
`;

export const DELETE_ASSET = gql`
  mutation DeleteAsset($asset: UpdateDeleteAssetInput) {
    deleteAsset(asset: $asset) {
      _id
      id
      customer_id
      customer_business_name
      contact_id
      name
      created_at
      updated_at
      asset_serial
      asset_type
      asset_type_id
      make
      model
      service_tag
      warranty
      warranty_type
      warranty_end_date
      warranty_start_date
    }
  }
`;

export const DELETE_ASSETS = gql`
  mutation DeleteAssets($assets: [UpdateDeleteAssetInput]) {
    deleteAssets(assets: $assets) {
      _id
      id
      customer_id
      customer_business_name
      contact_id
      name
      created_at
      updated_at
      asset_serial
      asset_type
      asset_type_id
      make
      model
      service_tag
      warranty
      warranty_type
      warranty_end_date
      warranty_start_date
    }
  }
`;

export const BULK_EDIT_ASSETS = gql`
  mutation BulkEditAsset($assets: [AssetInput]!) {
    bulkEditAssets(assets: $assets) {
      updated {
        id
        asset_serial
      }
      failed {
        asset_serial
        reason
      }
    }
  }
`;

export const BULK_UPLOAD_ASSETS = gql`
  mutation BulkUploadAssets($assets: [AssetInput]!) {
    bulkUploadAssets(assets: $assets) {
      created {
        id
        asset_serial
      }
      failed {
        asset_serial
        reason
      }
    }
  }
`;
